import React, { useState, useContext, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../.././../utils/secure-route/AuthContext";
import SettingTable from "../ManageSettings/SettingTable";
import useSwal from "../../../common/ReusableComponent/useSwal";
import atmdeposite from "../../../../assets/Image/Atm Deposite.png";
import CloseIcon from "../../../../assets/Image/close.png";
import { useToastHandler } from "../../../common/ToastHandler";
import CustomDateInput from "../../../../context/CustomDateInput";
import useFormattingUtils from "../../../../context/useFormattingUtils";
import ReusableTable from '../../../common/ReusableComponent/reusableTable/ReusableTable'

export default function GeneralLedgerATM() {
  const { user } = useContext(AuthContext);
  const { Get, Post, Delete, Put, getAPI, GetPaginatedData } = useApi();
  const { confirmDelete } = useSwal();
  const [loading, setLoading] = useState(false);
  const { handleToast } = useToastHandler();
  const storeid = user.store;

  const [banks, setBanks] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showModalAtm, setShowModalAtm] = useState(false);
  const { formatDate } = useFormattingUtils();
  const toggleModal = () => {
    if (showModalAtm) {
      resetFormData();
      setIsEditing(false);
      setCurrentRecord(null);
    }
    setShowModalAtm(!showModalAtm);

    if (!showModalAtm) {
      setTimeout(() => {
        document.activeElement.blur();
      }, 0);
    }
  };
  const [atmDeposit, setAtmDeposit] = useState();
  useEffect(() => {
    fetchBanks();
    fetchAtmData();
  }, []);

  const handleCheckboxChange = async (event) => {
    const isChecked = event.target.checked;
    setIsChecked(isChecked);

    if (isChecked) {
      try {

      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    }
  };

  const fetchAtmData = async ({ page = 1, searchTerm = "", sort = "", order = "" } = {}) => {
    try {
      setLoading(true);

      const response = await GetPaginatedData("transactionData", {
        page,
        search: searchTerm,
        queryParams: {
          ...(sort && { sort }),
          transaction_type: "ATM Deposit"
        }
      });

      const results = response?.data || [];
      const count = response?.totalCount || 0;
      const totalPages = Math.ceil(count / 10);

      const formatted = results.map((item) => ({
        ...item,
        date: item.date ? formatDate(item.date) : "N/A",
      }));

      setAtmDeposit(formatted);
      return { data: formatted, totalPages };
    } catch (error) {
      console.error("Error fetching ATM data:", error);

      const backendErrors = error?.response?.data;

      let errorMessage = "Failed to fetch ATM deposit data.";

      if (backendErrors && typeof backendErrors === "object") {
        const firstKey = Object.keys(backendErrors)[0];
        const messages = backendErrors[firstKey];
        if (Array.isArray(messages) && messages.length > 0) {
          errorMessage = messages[0]; 
        }
      }

      handleToast({
        type: "ERROR",
        message: errorMessage,
      });

      setAtmDeposit([]);
      return { data: [], totalPages: 1 };
    } finally {
      setLoading(false);
    }
  };

  const fetchBanks = async () => {
    try {
      const response = await Get("bank");
      const bankList = response?.results || [];
      setBanks(bankList);

    } catch (error) {
      console.error("Error fetching banks:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch banks.",
      });
    }
  };

  const handleDateChange = (e) => {
    const { value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      date: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "cheque_no" && !/^[0-9]*$/.test(value)) {
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const today = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    store: storeid,
    sr_no: 3,
    date: today,
    transaction_type: "ATM Deposit",
    bank: "",
    amount: "",
    cash_amount: "",
    cheque_amount: "",
    cheque_no: "",
    total_amount: "",
    pay_method_status: "pay_now",
    pay_method: "cash",
    note: "",
    atm_commission: "",
    income_type: null,
    bank_deposite_type: null,
    owner: null,
  });

  const handleAtmDeposit = async (event) => {
    event.preventDefault();

    const { sr_no, ...formDataWithoutSrNo } = formData;

    formDataWithoutSrNo.pay_method_status = null;

    if (!isChecked) {
      formDataWithoutSrNo.pay_method = null;
    }

    if (!formData.bank_deposite_type) {
      handleToast({
        type: "ERROR",
        message: "Please select a valid Deposit type.",
      });
      return;
    }

    if (!formData.amount) {
      handleToast({
        type: "ERROR",
        message: "Please Enter Amount"
      });
      return;
    }

    if (isChecked && formData.atm_commission) {
      const amount = parseFloat(formData.amount) || 0;
      const commission = parseFloat(formData.atm_commission) || 0;

      if (commission > amount) {
        handleToast({
          type: "ERROR",
          message: "ATM commission cannot be greater than the total amount."
        });
        return;
      }
    }

    try {
      const updatedFormData = {
        ...formDataWithoutSrNo,
        store: storeid,
      };

      if (isEditing) {
        const response = await Put(
          "transactionData",
          currentRecord.id,
          updatedFormData
        );

        if (response && (response.status === 200 || response.status === 204)) {
          handleToast({
            type: "SUCCESS",
            message: "ATM Deposit updated successfully!"
          });
          resetFormData();
          setIsEditing(false);
          setShowModalAtm(false);

          setRefreshTrigger(prev => prev + 1);
        }
      } else {
        const response = await Post("transactionData", updatedFormData);
        if (response && (response.status === 200 || response.status === 201)) {
          handleToast({
            type: "SUCCESS",
            message: "ATM Deposit added successfully!"
          });
          resetFormData();
          setShowModalAtm(false);

          setRefreshTrigger(prev => prev + 1);
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      const backendErrors = error?.response?.data;
      let errorMessage = "Submission failed. Please check your input.";

      if (backendErrors && typeof backendErrors === "object") {

        const errorKeys = Object.keys(backendErrors);
        if (errorKeys.length > 0) {
          const firstKey = errorKeys[0];
          const messages = backendErrors[firstKey];
          if (Array.isArray(messages) && messages.length > 0) {
            errorMessage = messages[0]; 
          } else if (typeof messages === "string") {
            errorMessage = messages;
          }
        }
      } else if (error.message) {
        errorMessage = error.message;
      }

      handleToast({
        type: "ERROR",
        message: errorMessage,
      });
    }
  };

  const resetFormData = () => {
    setIsChecked(false);
    setFormData({
      ...formData,
      date: today,
      amount: "",
      total_amount: "",
      cheque_no: "",
      note: "",
      atm_commission: "",
      owner: null,
      bank: "",
      cash_amount: "",
      cheque_amount: "",
      income_type: null,
      bank_deposite_type: null,
      pay_method: "cash",
      pay_method_status: "pay_now",
      store: storeid,
    });
  };

  const convertToInputFormat = (dateString) => {
    if (!dateString) return today;

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      const [month, day, year] = dateString.split('-');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return date.toISOString().split('T')[0];
    }

    return today;
  };

  const handleEditAtmDeposit = (recordOrId) => {
    console.log("Editing Record:", recordOrId);

    let record;

    if (typeof recordOrId === 'string') {

      record = atmDeposit?.find(item => item.id === recordOrId);
      if (!record) {
        console.error("Record not found for ID:", recordOrId);
        handleToast({
          type: "ERROR",
          message: "Error: Record not found.",
        });
        return;
      }
    } else if (recordOrId && typeof recordOrId === 'object' && recordOrId.id) {

      record = recordOrId;
    } else {
      console.error("Invalid record: Missing ID", recordOrId);
      handleToast({
        type: "ERROR",
        message: "Error: Cannot edit record, missing ID.",
      });
      return;
    }

    setIsEditing(true);
    setCurrentRecord(record);

    const hasCommission = record.atm_commission &&
      record.atm_commission.toString().trim() !== "" &&
      record.atm_commission !== "0";

    setIsChecked(hasCommission);

    setFormData({
      store: storeid,
      sr_no: 3,
      date: convertToInputFormat(record.date),
      transaction_type: "ATM Deposit",
      bank: record.bank || "",
      amount: record.amount || "",
      cash_amount: record.cash_amount || "",
      cheque_amount: record.cheque_amount || "",
      cheque_no: record.cheque_no || "",
      total_amount: record.total_amount || "",
      pay_method_status: "pay_now",
      pay_method: record.pay_method || "cash",
      note: record.note || "",
      atm_commission: record.atm_commission || "",
      income_type: record.income_type || null,
      bank_deposite_type: record.bank_deposite_type || "",
      owner: record.owner || null,
    });

    setShowModalAtm(true);
  };
  const handleDeleteAtmDeposit = async (id) => {
    const result = await confirmDelete();
    if (!result.isConfirmed) return;
    try {
      await Delete("transactionData", id);

      setRefreshTrigger((prev) => prev + 1);

      handleToast({
        type: "SUCCESS",
        message: "ATM Deposit deleted successfully!",
      });
    } catch (error) {
      handleToast({
        type: "ERROR",
        message:
          "Error deleting ATM Deposit: " +
          (error.response ? error.response.data : error.message),
      });
    }
  };

  const formattedGeneralLedgerATM = atmDeposit?.map((item) => ({
    ...item,
    date: item.date ? formatDate(item.date) : "N/A",
  }));

  const columns = [
    { header: "Sr", field: "sr_no" },
    { header: "Date", field: "date" },
    { header: "Type", field: "bank_deposite_type" },

    { header: "Atm Commission", field: "atm_commission" },
    { header: "Amount", field: "amount" },
  ];
  return (
    <>
      <ToastContainer />
      <div className="responsive-box">
        <div className="">
          <div className="header-row mb-4">
            <div className="setting-title" style={{ marginLeft: "8px" }}>
              ATM Deposit
            </div>
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#FFAF32",
                boxShadow: "none",
                outline: "none",
                width: "auto",
                height: "42px",
                padding: "8px 12px",
                fontSize: "14px",
                border: "none",
                borderRadius: "10px",
                color: "#000",
                marginLeft: "50px",
                cursor: "pointer",
                fontWeight: "bold",

                gap: "8px",
              }}
              onClick={() => {
                setIsEditing(false);
                setCurrentRecord(null);
                toggleModal();
              }}
            >

              Add ATM Deposit
              <img
                src={atmdeposite}
                alt="Atm Deposite Icon"
                style={{ width: "20px", height: "20px", marginLeft: "18px" }}
              />
            </button>
          </div>

          {showModalAtm && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1000,
              }}
              onClick={toggleModal}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: "700px",
                  backgroundColor: "white",
                  margin: "100px auto",

                  borderRadius: "20px",
                  position: "relative",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div className="modal-header" style={{ border: "none" }}>
                  <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                    {isEditing ? "Edit ATM Deposit" : "Add ATM Deposit"}
                  </h5>

                  <img
                    src={CloseIcon}
                    alt="Close"
                    width="34"
                    height="34"
                    onClick={toggleModal}
                  />
                </div>
                <div className="modal-body">
                  <form onSubmit={handleAtmDeposit}>
                    <div className="form-row">
                      { }

                      { }
                      <div
                        className="form-group col-10"
                        style={{ marginLeft: "55px" }}
                      >
                        <div
                          className="d-flex gap-5 align-items-center"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          { }
                          { }
                          <CustomDateInput

                            value={formData.date || today}
                            onChange={handleDateChange}
                            required
                            readOnly={true}
                            inputStyle={{
                              backgroundColor: "#ffffff",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              borderRadius: "0px",
                              height: "52px",
                              flex: 1,

                            }}
                          />
                          { }
                          <div
                            className="input-group"
                            style={{
                              backgroundColor: "#ffffff",
                              border: "none",

                              borderRadius: "0px",
                              height: "52px",
                              marginBottom: '20px',
                              flex: 1,
                            }}
                          >
                            <input
                              type="text"
                              name="amount"
                              className="form-control-borderless"
                              value={formData.amount}
                              onChange={handleChange}
                              placeholder="Amount"
                              aria-label="Amount"
                              aria-describedby="addon-wrapping"
                              onInput={(e) => {

                                e.target.value = e.target.value
                                  .replace(/[^0-9.]/g, "")
                                  .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                                  .slice(0, 12);
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="" style={{ marginLeft: "55px" }}>
                        <div className="form-row d-flex col-md-5">
                          <select
                            style={{
                              backgroundColor: "#ffffff",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              borderRadius: "0px",
                              height: "52px",
                            }}
                            className="form-control-borderless"
                            id="bank_deposite_type"
                            name="bank_deposite_type"
                            value={formData.bank_deposite_type}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Cash Type</option>
                            <option value="Business cash">Business Cash</option>
                            <option value="Gas cash">Gas Cash</option>
                            <option value="Lottery cash">Lottery Cash</option>
                          </select>
                        </div>
                      </div>
                      <div
                        className="form-row d-flex col-md-12"
                        style={{
                          padding: "10px",
                          marginLeft: "45px",
                          alignItems: "center",
                        }}
                      >
                        <label style={{ marginRight: "20px" }}>
                          Do you want to Add ATM Commission? &nbsp;
                          <input
                            type="checkbox"
                            id="prepaidTax"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                          />
                        </label>

                        {isChecked && (
                          <input
                            type="text"
                            className="form-control-borderless"
                            aria-label="ATM Commission Amount"
                            placeholder="Amount"
                            name="atm_commission"
                            value={formData.atm_commission}
                            onChange={handleChange}
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                                .slice(0, 12);
                            }}
                            style={{
                              marginLeft: "10px",
                              height: "50px",
                              width: "188px",
                              border: "none",
                              borderBottom: "1px solid #ccc",
                              borderRadius: "0px",
                            }}
                          />
                        )}
                      </div>

                      { }
                      {isChecked && (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            border: "1px solid #ACB4AA",
                            padding: "5px 5px",
                            width: "fit-content",
                            borderRadius: "40px",
                            marginTop: "10px",
                            marginBottom: "20px",
                            marginLeft: "52px",
                            marginRight: "auto",
                            gap: "10px",
                          }}
                        >
                          { }
                          {["cash", "bank", "cheque"].map((method) => (
                            <div
                              key={method}
                              className="form-check"
                              style={{
                                backgroundColor:
                                  formData.pay_method === method
                                    ? "#4a5546"
                                    : "transparent",
                                borderRadius: "20px",
                                padding: "5px 15px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleChange({
                                  target: { name: "pay_method", value: method },
                                })
                              }
                            >
                              <input
                                type="radio"
                                className="form-check-input"
                                name="pay_method"
                                value={method}
                                checked={formData.pay_method === method}
                                onChange={handleChange}
                                style={{ display: "none" }}
                              />
                              <label
                                className="form-check-label"
                                style={{
                                  color:
                                    formData.pay_method === method
                                      ? "#fff"
                                      : "#000",
                                }}
                              >
                                {method === "bank"
                                  ? "Bank Card (ACH/EFT)"
                                  : method.charAt(0).toUpperCase() +
                                  method.slice(1)}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}

                      {(formData.pay_method === "bank" ||
                        formData.pay_method === "cheque") && (
                          <div className="d-flex align-items-center mb-3 mt-2">
                            { }
                            <div className="col-md-4">
                              <select
                                style={{
                                  marginLeft: "52px",
                                  height: "52px",
                                }}
                                className="input-select w-100"
                                name="bank"
                                value={formData.bank}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select a bank</option>
                                {banks?.map((bank) => (
                                  <option key={bank.id} value={bank.id}>
                                    {bank.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            { }
                            {formData.pay_method === "cheque" && (
                              <div className="col-md-4 ms-3">
                                <input
                                  style={{
                                    height: "52px",
                                    marginLeft: "70px",
                                  }}
                                  className="input-select w-100"
                                  type="text"
                                  name="cheque_no"
                                  value={formData.cheque_no || ""}
                                  placeholder="Cheque No"
                                  onChange={handleChange}
                                  maxLength={20}
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                />
                              </div>
                            )}
                          </div>
                        )}
                    </div>
                    <div className="modal-footer" style={{ border: "none" }}>
                      <button
                        type="button"
                        className="btn btn-secondary-outline"
                        onClick={toggleModal}
                        style={{
                          border: " 1px solid #282e26",
                          borderRadius: "50px",
                          width: "181px",
                          height: "45px",
                          fontWeight: "bold",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn"
                        style={{
                          color: "white",
                          backgroundColor: "#282e26",
                          borderRadius: "50px",
                          width: "181px",
                          height: "45px",
                          fontWeight: "bold",
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          <ReusableTable
            fetchData={fetchAtmData}
            columns={columns}
            showFooter={true}
            showAction={true}
            showExport={true}
            showFilter={false}
            itemsPerPage={10}
            enablePagination={true}
            key={refreshTrigger}
            onEdit={handleEditAtmDeposit}
            onDelete={handleDeleteAtmDeposit}
          />
        </div>
      </div>
    </>
  );
}